<template>
  <div class="store-credit-container">
    <div class="main">
      <div>{{data.credit||'--'}}</div>
      <div v-if="userAuth.can_store_customer_credit" class="handle" @click="click"><i class="el-icon-edit"/></div>
    </div>
  </div>
</template>

<script>
import {MessageBox} from 'element-ui';
import {storeCredit} from "@/api/customers";

export default {
  name: "StoreCredit",
  props: {
    // {id: null, name: null, credit: null}
    data: {
      type: Object,
      required: true
    }
  },
  computed: {
    userAuth() {
      return this.$store.getters.getUserAuth;
    },
  },
  methods: {
    click() {
      const _this = this;
      MessageBox.prompt(`请输入「${_this.data.name}」的信用描述`, '客户信用', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[\u4e00-\u9fa5_a-zA-Z0-9_\s]{0,50}$/,
        // inputPattern: /^(.*){0,50}$/,
        inputValue: _this.data.credit,
        inputErrorMessage: '最多输入50字'
      }).then(async ({value}) => {
        const response = await storeCredit({id: _this.data.id, credit: value});
        if (!response.success) {
          _this.showToast({h: _this, icon: "el-icon-error", text: response.message, duration: 2000});
          return false;
        }
        _this.$emit('success')
        _this.showToast({h: _this, icon: "el-icon-success", text: "操作成功", duration: 2000});
      })
    }
  }
}
</script>

<style lang="scss">
.store-credit-container {
  .main {
    display: flex;
    justify-content: space-between;

    div:first-child {
      width: 80px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }

    .handle {
      color: #ff3176;
    }
  }
}
</style>
